export default function externalLinks() {
  /**
   * External links open in new tab
   */
  $('a')
    .filter(function () {
      const href = $(this).attr('href') || '';
      const internal =
        href === '' ||
        href.includes('localhost') ||
        href.includes(wordpress.siteurl) ||
        href.includes('mailto:') ||
        href.includes('tel:') ||
        href.startsWith('#') ||
        (href.startsWith('/') && !href.startsWith('//'));
      const languageSwitcher = $(this).hasClass('wpml-ls-link');
      return !internal && !languageSwitcher;
    })
    .each(function () {
      $(this).attr('target', '_blank');
      $(this).addClass('external-link');
    });
}
